// @flow
export default function guardNegativeOrZeroNumber(number: ?number): ?number {
  if (number == null) {
    return undefined;
  }

  if (number <= 0) {
    return undefined;
  }

  return number;
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/utils/guardNegativeOrZeroNumber.js